import React, { Component } from "react";
import YouTube from "react-youtube";
// import cleverTap from "../../common/clevertap";

class Youtube extends Component {
  componentDidMount() {
    // const cleverTap_data = this.videoStated(this.props.data, this.props.Auth);
    // cleverTap.videoPlayed(cleverTap_data);
  }
  videoStated = (data, auth) => {
    if (data.length > 0) {
      const genre = this.getGenreInfo(data);
      const language = data[0].content.language.join();
      const contentType = data[0].generalInfo.type;
      let consumption_type = "";
      if (localStorage.getItem("Logged-in") && data[0].videos.values.length > 0) {
        consumption_type = data[0].videos.values[0].type;
      }
      return {
        "content id": data[0]._id,
        "content name": data[0].generalInfo.title,
        genre: genre,
        "content type": contentType,
        language: language,
        "content partner name": data[0].publishingHouse.publishingHouseName,
        "consumption type": consumption_type,
        mode: "direct",
        category: contentType,
        "registered user": auth ? "yes" : "no",
        source: localStorage.getItem("source"),
        "source details": localStorage.getItem("source details"),
        "trackingId":localStorage.getItem('trackingId'),
        tab: localStorage.getItem("menu")
      };
    }
  };
  getGenreInfo = data => {
    const genre = [];
    data[0].content.genre.map(value => genre.push(value.name));
    return genre.join();
  };

  componentWillUnmount() {
    // const cleverTap_data = this.videoStated(this.props.data, this.props.Auth);
    // cleverTap.videoStoped(cleverTap_data);
  }

  _onPlay(event, auth) {
    if (auth === false) {
      event.target.stopVideo();
      document.getElementById("profile_img").click();
    } else {
      event.target.playVideo();
    }
  }
  render() {
    let opts = null;
    if (this.props.Auth === "true") {
      opts = {
        width: "100%",
        height: "100%",
        playerVars: {
          autoplay: 1
        }
      };
    } else {
      opts = {
        width: "100%",
        height: "100%",
        playerVars: {
          autoplay: 0
        }
      };
    }
    return (
      <div className="youtube-container">
        <YouTube
          onPlay={event => this._onPlay(event, this.props.Auth)}
          videoId={this.props.videoId}
          opts={opts}
        />
      </div>
    );
  }
}
export default Youtube;
